import cacheKeyFields from './cacheKeyFields';
import cacheMergePolicies from './cacheMergePolicies';
import cacheQueryPolicies from './cacheQueryPolicies';
import possibleTypes from './possibleTypes.json';
import { HubspotInMemoryCache } from 'hubspot-apollo-cache';
function getTypePolicies() {
  return [...Object.keys(cacheMergePolicies), ...Object.keys(cacheKeyFields), ...Object.keys(cacheQueryPolicies)].reduce((typePolicies, typeName) => {
    return Object.assign({}, typePolicies, {
      [typeName]: Object.assign({}, cacheMergePolicies[typeName], cacheKeyFields[typeName], cacheQueryPolicies[typeName])
    });
  }, {});
}
export const createCache = () => new HubspotInMemoryCache({
  location: 'hubspot-apollo-client',
  canonizeResults: true,
  possibleTypes,
  typePolicies: getTypePolicies()
});